import { AnimatePresence as Presence , motion as Motion } from 'framer-motion';
import { ref as Reference , update as Edit , onValue as Listener } from "firebase/database";
import { useParams as Params } from "react-router-dom";
import { useState as State , useEffect as Fx , useRef as Ref } from "react";
import { collection , getDocs } from "firebase/firestore";
import Cloudinaries from "../../Configuration/Cloudinary.Use";
import { Firestore } from '../../Configuration/Firestore.Firebase';
import { Realtime } from '../../Configuration/Realtime.Firebase';

const Order = () => {

    const { Table } = Params();
    
    const Animation = Motion['section'];

    const [ Bill , SET_Bill ] = State(false);

    const [ Details , SET_Details ] = State({});

    const [ Items , SET_Items ] = State([]);
    const [ Categories , SET_Categories ] = State([]);

    const [ Category , SET_Category ] = State(0);

    async function Load() {
        const Categoriess = await getDocs( collection( Firestore , "Category" ) );
        const Prioritised = Categoriess.docs.map(doc => ({ id: doc.id , open: false, ...doc.data() })).sort((a, b) => a.Priority - b.Priority);
        Prioritised[Category].open = true;
        SET_Categories( Prioritised );
        const Itemss = await getDocs( collection( Firestore , "Items" ) );
        const Mapped = Itemss.docs.map( doc => ( { id: doc.id , expanded : false , cart : false , quantity : 0 , ...doc.data() } ) );
        SET_Items( Mapped );
        Listen(
            ( Data ) => {
                SET_Details( Data );
                if (!Data?.Items) {
                    let Updated = Mapped.map(
                        Item => {
                            Item.cart = false;
                            Item.quantity = 0;
                            return Item;
                        }
                    );
                    SET_Items( Updated );
                } else {
                    let Updated = Mapped.map(
                        Item => {
                            if (Data.Items.find( In => In.id === Item.id )) {
                                Item.cart = true;
                                Item.quantity = Data.Items.find( In => In.id === Item.id ).quantity;
                            };
                            return Item;
                        }
                    );
                    SET_Items( Updated );
                };
            }
        );
    };

    async function Change( Index ) {
        const Updated = Categories;
        Updated[Category].open = false;
        Updated[Index].open = true;
        SET_Category( Index );
        SET_Categories( Updated );
    };

    async function Expand( ID ) {
        const Updated = Items.map(
            Item => {
                if ( Item.id === ID ) {
                    Item.expanded = !Item.expanded;
                } else {
                    Item.expanded = false;
                };
                return Item;
            }
        );
        SET_Items( Updated );
    };

    async function Cart( ID ) {
        const Updated = Items.map(
            Item => {
                if ( Item.id === ID ) {
                    Item.cart = true;
                    Item.quantity = 1;
                };
                return Item;
            }
        );
        SET_Items( Updated );
        Edit(
            Reference( Realtime , `Tables/${Table}` ) ,
            {
                Items : Updated.filter(
                    Item => Item.cart === true
                ).length === 0 ? [] : Updated.filter(
                    Item => Item.cart === true
                ).map(
                    Item => (
                        {
                            id: Item.id,
                            quantity: Item.quantity
                        }
                    )
                ),
            }
        );
    }

    async function Quantity( ID , Quantity ) {
        const Updated = Items.map(
            Item => {
                if ( Item.id === ID ) {
                    if (Quantity === 0) {
                        Item.cart = false;
                        Item.quantity = 0;
                    } else {
                        Item.quantity = Quantity;
                    }
                };
                return Item;
            }
        );
        SET_Items( Updated );
        Edit(
            Reference( Realtime , `Tables/${Table}` ) ,
            {
                Items : Updated.filter(
                    Item => Item.cart === true
                ).length === 0 ? [] : Updated.filter(
                    Item => Item.cart === true
                ).map(
                    Item => (
                        {
                            id: Item.id,
                            quantity: Item.quantity
                        }
                    )
                ),
            }
        );
    }

    function Swiper( Left , Right , Hold = 50) {
        const startX = Ref(0);
        const endX = Ref(0);
        const onTouchStart = (e) => {
            startX.current = e.touches[0].clientX;
        };
        const onTouchMove = (e) => {
            endX.current = e.touches[0].clientX;
        };
        const onTouchEnd = () => {
            const diff = startX.current - endX.current;
            if (diff > Hold) Left();
            else if (diff < -Hold) Right();
        };
        return { onTouchStart, onTouchMove, onTouchEnd };
    };

    const Swipers = Swiper(
        () => {},
        () => {}
    );

    function Listen( Callback ) {
        const Refs = Reference( Realtime , `Tables/${Table}`);
        return Listener(
            Refs , Snapshot => {
                Callback(
                    Snapshot.exists() ? Snapshot.val() : null
                );
            }
        );
    };

    Fx(
        () => {
            Load();
        }, []
    );

    return(
        <section className="TFZC-Order-Panel" >
            <Presence mode='wait'>
                <Animation key={Bill} initial={ { opacity : 0 } } animate={ { opacity : 1 } } exit={ { opacity : 0 } } transition={ { duration: 0.2, ease: "easeIn" } } className="Animated-Switcher-Order" >
                    {
                        Bill
                        ? <section className="TFZC-Order-Panel-Bill-Filter" style={ { "display" : "flex" , "flexDirection" : "column" , "justifyContent" : "space-between" } } >
                            <div className="TFZC-Order-Panel-Bill-Header" >
                                <h2 className="TFZC-Order-Panel-Header-Info-Tab-Title" >Friend Zone</h2>
                                <button className="TFZC-Order-Panel-Bill-Header-Back" onClick={ () => SET_Bill(false) } >Go Back</button>
                            </div>
                            {
                                Items.filter( Item => Item.cart === true ).length === 0
                                ? <section className="TFZC-Order-Panel-Bill-Empty" >
                                    <p className="TFZC-Order-Panel-Bill-Empty-Title" >No Items in Cart</p>
                                    <button className="TFZC-Order-Panel-Bill-Header-Back" onClick={ () => SET_Bill(false) } >Menu</button>
                                </section>
                                : <section className="TFZC-Order-Panel-Bill-Filled" >
                                    <section className="TFZC-Order-Panel-Bill-Filled-Items" >
                                        {
                                            Items.filter( Item => Item.cart === true ).map(
                                                ( Item ) => <item-card-wrapper key={Item.id} className="TFZC-Order-Panel-Item-Card-Wrapper" > 
                                                    <item-card className={ Item.expanded ? "TFZC-Order-Panel-Item-Card TFZC-Order-Panel-Item-Card-Expanded" : "TFZC-Order-Panel-Item-Card" } >
                                                        {
                                                            !Item.expanded
                                                            ? <item-card-min className="TFZC-Order-Panel-Item-Card-Min" >
                                                                <div className="TFZC-Order-Panel-Item-Card-Min-Image-Wrapper" onClick={ () => Expand( Item.id ) } >
                                                                    <img className="TFZC-Order-Panel-Item-Card-Min-Image" src={Cloudinaries.Use( { Name : Item.Image } )} alt="Item View" />
                                                                </div>
                                                                <div className="TFZC-Order-Panel-Item-Card-Min-Info-Wrapper" >
                                                                    <h3 className="TFZC-Order-Panel-Item-Card-Min-Info-Title" onClick={ () => Expand( Item.id ) } >{ Item.Name }</h3>
                                                                    <h4 className="TFZC-Order-Panel-Item-Card-Min-Info-Price" onClick={ () => Expand( Item.id ) } >₹{ Item.Price.toFixed(2) }</h4>
                                                                    <div className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Button-Wrapper" >
                                                                        {
                                                                            Item.cart
                                                                            ? <div className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Quantity-Button-Wrapper" >
                                                                                <button className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Quantity-Button" onClick={ () => Quantity( Item.id , Item.quantity - 1 ) } >-</button>
                                                                                <span className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Button-Quantity" >{ Item.quantity }</span>
                                                                                <button className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Quantity-Button" onClick={ () => Quantity( Item.id , Item.quantity + 1 ) } >+</button>
                                                                            </div>
                                                                            : <button className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Button" onClick={ () => Cart(Item.id) } >Order</button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </item-card-min>
                                                            : <item-card-max className="TFZC-Order-Panel-Item-Card-Max" {...Swipers} >
                                                                <div className="TFZC-Order-Panel-Item-Card-Max-Header" >
                                                                    <div className="TFZC-Order-Panel-Item-Card-Max-Header-Back-Button-Wrapper" >
                                                                        <div className="TFZC-Order-Panel-Item-Card-Max-Header-Back-Button" onClick={ () => Expand( Item.id ) } >
                                                                            <img className="TFZC-Order-Panel-Item-Card-Max-Header-Back-Button-Icon" src="/Icons/Back.png" alt="Back Icon" />
                                                                        </div>
                                                                    </div>
                                                                    <h2 className="TFZC-Order-Panel-Item-Card-Max-Header-Title" >{ Categories[Category].Name }</h2>
                                                                    <div className="TFZC-Order-Panel-Item-Card-Max-Header-Back-Button-Wrapper" ></div>
                                                                </div>
                                                                <div className="TFZC-Order-Panel-Item-Card-Max-Image-Wrapper" >
                                                                    <img className="TFZC-Order-Panel-Item-Card-Max-Image" src={Cloudinaries.Use( { Name : Item.Image } )} alt="Item Expanded View" />
                                                                </div>
                                                                <div className="TFZC-Order-Panel-Item-Card-Max-Name" >{Item.Name}</div>
                                                                <div className="TFZC-Order-Panel-Item-Card-Max-Description" >{Item.Description}</div>
                                                                {
                                                                    Item.cart
                                                                    ? <div className="TFZC-Order-Panel-Item-Card-Max-Quantity-Button-Wrapper" >
                                                                        <button className="TFZC-Order-Panel-Item-Card-Max-Quantity-Button" onClick={ () => Quantity( Item.id , Item.quantity - 1 ) } >-</button>
                                                                        <span className="TFZC-Order-Panel-Item-Card-Max-Quantity" >{ Item.quantity }</span>
                                                                        <button className="TFZC-Order-Panel-Item-Card-Max-Quantity-Button" onClick={ () => Quantity( Item.id , Item.quantity + 1 ) } >+</button>
                                                                    </div>
                                                                    : <button className="TFZC-Order-Panel-Item-Card-Max-Cart-Button" onClick={ () => Cart(Item.id) } >Cart - ₹{ Item.Price.toFixed(2) }</button>
                                                                }
                                                            </item-card-max>
                                                        }
                                                    </item-card>
                                                </item-card-wrapper>
                                            )
                                        }
                                    </section>
                                </section>
                            }
                            {
                                Items.filter( Item => Item.cart === true ).length === 0
                                ? null
                                : <div className="TFZC-Order-Panel-Bill-Filled-Total-Wrapper" >
                                    <h5 className="TFZC-Order-Panel-Bill-Filled-Total-Text" >Bill Total</h5>
                                    <h5 className="TFZC-Order-Panel-Bill-Filled-Total-Text" >{Items.filter( Item => Item.cart === true ).reduce( ( Sum , Item ) => Sum + (Item.quantity * Item.Price) , 0 )} ₹</h5>
                                </div>
                            }
                            {
                                Items.filter( Item => Item.cart === true ).length === 0
                                ? null
                                : <div className="TFZC-Order-Panel-Bill-Button-Wrapper" >
                                    <button className="TFZC-Order-Panel-Bill-Button" >{ Details.Status === "Available" ? "Place Order" : Details.Status === "Cooking" || Details.Status === "Accepted"  ? "Update Order" : "Cancle Order" }</button>
                                </div>
                            }
                        </section>
                        : <section className="TFZC-Order-Panel-Filter" >
                            <header className="TFZC-Order-Panel-Header" >
                                <div className="TFZC-Order-Panel-Header-Info-Tab" >
                                    <h2 className="TFZC-Order-Panel-Header-Info-Tab-Title" >Friend Zone</h2>
                                    {
                                        Items.filter( Item => Item.cart === true ).length > 0
                                        ? <div className="TFZC-Order-Panel-Header-Info-Tab-Extended" onClick={ () => SET_Bill(true) } >
                                            <div className="TFZC-Order-Panel-Header-Info-Tab-Extended-Basket-Button" >
                                                <img className="TFZC-Order-Panel-Header-Info-Tab-Extended-Basket-Button-Icon" src="/Icons/Cart-Basket.png" alt="Cart Icon" />
                                            </div>
                                            <div className="TFZC-Order-Panel-Header-Info-Tab-Extended-Basket-Button" >{ Items.filter( Item => Item.cart === true ).reduce( ( Sum , Item ) => Sum + Item.quantity , 0 ) }</div>
                                        </div>
                                        : <div className="TFZC-Order-Panel-Header-Info-Tab-Basket-Button" onClick={ () => SET_Bill(true) } >
                                            <img className="TFZC-Order-Panel-Header-Info-Tab-Basket-Icon" src="/Icons/Cart-Basket.png" alt="Cart Icon" />
                                        </div>
                                    }
                                </div>
                                <div className="TFZC-Order-Panel-Header-Filter-Tab" >
                                    {
                                        Categories.map(
                                            ( Category , Index ) => <button key={Category.id} className={ Category.open ? "TFZC-Order-Panel-Header-Filter-Tab-Buttons-Active" : "TFZC-Order-Panel-Header-Filter-Tab-Buttons" } onClick={ () => Change(Index) } >
                                                { Category.Name }
                                            </button>
                                        )
                                    }
                                </div>
                            </header>
                            <section className="TFZC-Order-Panel-Items" >
                                {
                                    Items.filter( Item => Item.Category === Categories[Category]?.id ).map(
                                        ( Item ) => <item-card-wrapper key={Item.id} className="TFZC-Order-Panel-Item-Card-Wrapper" > 
                                            <item-card className={ Item.expanded ? "TFZC-Order-Panel-Item-Card TFZC-Order-Panel-Item-Card-Expanded" : "TFZC-Order-Panel-Item-Card" } >
                                                {
                                                    !Item.expanded
                                                    ? <item-card-min className="TFZC-Order-Panel-Item-Card-Min" >
                                                        <div className="TFZC-Order-Panel-Item-Card-Min-Image-Wrapper" onClick={ () => Expand( Item.id ) } >
                                                            <img className="TFZC-Order-Panel-Item-Card-Min-Image" src={Cloudinaries.Use( { Name : Item.Image } )} alt="Item View" />
                                                        </div>
                                                        <div className="TFZC-Order-Panel-Item-Card-Min-Info-Wrapper" >
                                                            <h3 className="TFZC-Order-Panel-Item-Card-Min-Info-Title" onClick={ () => Expand( Item.id ) } >{ Item.Name }</h3>
                                                            <h4 className="TFZC-Order-Panel-Item-Card-Min-Info-Price" onClick={ () => Expand( Item.id ) } >₹{ Item.Price.toFixed(2) }</h4>
                                                            <div className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Button-Wrapper" >
                                                                {
                                                                    Item.cart
                                                                    ? <div className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Quantity-Button-Wrapper" >
                                                                        <button className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Quantity-Button" onClick={ () => Quantity( Item.id , Item.quantity - 1 ) } >-</button>
                                                                        <span className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Button-Quantity" >{ Item.quantity }</span>
                                                                        <button className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Quantity-Button" onClick={ () => Quantity( Item.id , Item.quantity + 1 ) } >+</button>
                                                                    </div>
                                                                    : <button className="TFZC-Order-Panel-Item-Card-Min-Info-Cart-Button" onClick={ () => Cart(Item.id) } >Order</button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </item-card-min>
                                                    : <item-card-max className="TFZC-Order-Panel-Item-Card-Max" {...Swipers} >
                                                        <div className="TFZC-Order-Panel-Item-Card-Max-Header" >
                                                            <div className="TFZC-Order-Panel-Item-Card-Max-Header-Back-Button-Wrapper" >
                                                                <div className="TFZC-Order-Panel-Item-Card-Max-Header-Back-Button" onClick={ () => Expand( Item.id ) } >
                                                                    <img className="TFZC-Order-Panel-Item-Card-Max-Header-Back-Button-Icon" src="/Icons/Back.png" alt="Back Icon" />
                                                                </div>
                                                            </div>
                                                            <h2 className="TFZC-Order-Panel-Item-Card-Max-Header-Title" >{ Categories[Category].Name }</h2>
                                                            <div className="TFZC-Order-Panel-Item-Card-Max-Header-Back-Button-Wrapper" ></div>
                                                        </div>
                                                        <div className="TFZC-Order-Panel-Item-Card-Max-Image-Wrapper" >
                                                            <img className="TFZC-Order-Panel-Item-Card-Max-Image" src={Cloudinaries.Use( { Name : Item.Image } )} alt="Item Expanded View" />
                                                        </div>
                                                        <div className="TFZC-Order-Panel-Item-Card-Max-Name" >{Item.Name}</div>
                                                        <div className="TFZC-Order-Panel-Item-Card-Max-Description" >{Item.Description}</div>
                                                        {
                                                            Item.cart
                                                            ? <div className="TFZC-Order-Panel-Item-Card-Max-Quantity-Button-Wrapper" >
                                                                <button className="TFZC-Order-Panel-Item-Card-Max-Quantity-Button" onClick={ () => Quantity( Item.id , Item.quantity - 1 ) } >-</button>
                                                                <span className="TFZC-Order-Panel-Item-Card-Max-Quantity" >{ Item.quantity }</span>
                                                                <button className="TFZC-Order-Panel-Item-Card-Max-Quantity-Button" onClick={ () => Quantity( Item.id , Item.quantity + 1 ) } >+</button>
                                                            </div>
                                                            : <button className="TFZC-Order-Panel-Item-Card-Max-Cart-Button" onClick={ () => Cart(Item.id) } >Cart - ₹{ Item.Price.toFixed(2) }</button>
                                                        }
                                                    </item-card-max>
                                                }
                                            </item-card>
                                        </item-card-wrapper>
                                    )
                                }
                            </section>
                        </section>
                    }
                </Animation>
            </Presence>
        </section>
    );

};

export default Order;